import amazon from './Amazon.svg'
import bluetooth from './Bluetooth.svg'
import crackle from './crackle.svg'
import hbogo from './hbo.svg'
import hulu from './hulu.svg'
import netflix from './Netflix.svg'
import pandora from './pandora.svg'
import showtime from './Showtime.svg'
import youtube from './youtube.svg'
import max from './max.svg'
import plutotv from './plutotv.svg'
import amasian from './amasian.svg'
import fubo from './fubo.svg'
import ufc from './ufc.svg'
import redbull from './Red_Bull_TV.svg'
import peloton from './peloton.svg'
import haystack from './haystack.svg'
import tv5modeplus from './TV5MondePlus.svg'
import ondemand_korea from './ondemand_korea.svg'
import shahid from './shahid.svg'
import peacock from './peacock.svg'
import vidio from './vidio.svg'
import youtubetv from './youtubetv.svg'
const images = {
   'Amazon Prime Video': amazon,
   'Bluetooth': bluetooth,
   'Crackle': crackle,
   'HBO GO': hbogo,
   'Hulu': hulu,
   'Netflix': netflix,
   'Pandora': pandora,
   'Showtime': showtime,
   'YouTube': youtube,
   'MAX': max, 
   'Pluto TV': plutotv,
   'Amasian': amasian,
   'Fubo': fubo,
   'UFC': ufc,
   'Red Bull TV': redbull,
   'Peloton': peloton,
   'Haystack': haystack,
   'TV5 Monde Plus': tv5modeplus,
   'OnDemand Korea': ondemand_korea,
   'Shahid': shahid,
   'Vidio': vidio,
   'Peacock': peacock,
   'YouTube TV': youtubetv,
} 

export default images